import { render, staticRenderFns } from "./OnboardingNavDrawer.vue?vue&type=template&id=e5dbab54&scoped=true"
import script from "./OnboardingNavDrawer.vue?vue&type=script&lang=js"
export * from "./OnboardingNavDrawer.vue?vue&type=script&lang=js"
import style0 from "./OnboardingNavDrawer.vue?vue&type=style&index=0&id=e5dbab54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dbab54",
  null
  
)

export default component.exports